import { HiChevronDoubleLeft, HiChevronDoubleRight } from 'react-icons/hi';
import Wrapper from '../../assets/wrappers/PageBtnContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAllCampaignsContext } from '../../pages/AllCampaigns';

const CampaignPaginationContainer = () => {
  const {
    data: { numOfPages, currentPage },
  } = useAllCampaignsContext();

  const pages = Array.from({ length: numOfPages }, (_, i) => i + 1);
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set('page', pageNumber);
    navigate(`${pathname}?${searchParams.toString()}`);
  };

  const renderPageButtons = () =>
    pages.map((pageNumber) => (
      <button
        key={pageNumber}
        onClick={() => handlePageChange(pageNumber)}
        className={`btn page-btn ${currentPage === pageNumber ? 'active' : ''}`}
      >
        {pageNumber}
      </button>
    ));

  return (
    <Wrapper>
      <button
        className="btn prev-btn"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <HiChevronDoubleLeft /> Prev
      </button>
      <div className="btn-container">{renderPageButtons()}</div>
      <button
        className="btn next-btn"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === numOfPages}
      >
        Next <HiChevronDoubleRight />
      </button>
    </Wrapper>
  );
};

export default CampaignPaginationContainer;
